import type { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import type { HTMLString } from 'shared/types/html-string'
export type FieldErrorAndDescriptionProps = {
  description?: React.ReactNode
  descriptionClassName?: string
  error?: HTMLString | string | null
  errorClassName?: string
}

function Description({
  description,
  descriptionClassName,
}: Pick<FieldErrorAndDescriptionProps, 'description' | 'descriptionClassName'>): ReactNode | null {
  if (!description) {
    return null
  }

  return (
    <span className={twMerge('text-sm opacity-70 [&>a]:text-brand-primary', descriptionClassName)}>
      {description}
    </span>
  )
}

function Error({
  error,
  errorClassName,
}: Pick<FieldErrorAndDescriptionProps, 'error' | 'errorClassName'>): ReactNode | null {
  if (!error) {
    return null
  }

  return (
    <p
      className={twMerge('text-sm text-danger', errorClassName)}
      dangerouslySetInnerHTML={{ __html: error }}
    />
  )
}

export function FieldErrorAndDescription({
  description,
  descriptionClassName,
  error,
  errorClassName,
}: FieldErrorAndDescriptionProps): ReactNode | null {
  if (typeof error == 'string' || description) {
    return (
      <div>
        <Description description={description} descriptionClassName={descriptionClassName} />
        <Error error={error} errorClassName={errorClassName} />
      </div>
    )
  }

  return null
}
